module.exports = __webpack_public_path__ + "static/media/04d.5a81a676.svg";